<!-- Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">Local-System Acct Mapping</h3>
  <div class="header-actions">
    <i class="fa"
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;"
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- Modal Body -->
<div class="modal-body" [hidden]="minimise">
  <div class="divShadow">
    <form class="form-horizontal" novalidate>

      <!-- Loader -->
      @if (showFormLoader) {
<div class="formLoader">
        <i class="fa fa-spinner fa-spin gt-refresh"></i>
      </div>
}

      <!-- Form Content -->
      @if (!showFormLoader) {
<div class="form-content">
        
        <!-- Account Info Row - ALL 4 FIELDS IN ONE LINE -->
        <div class="row account-info-row">
          <div class="field-group" style="width: 12%;">
            <label>Acct Type:</label>
            <input type="text" class="form-control input-sm" [value]="firLocalChartAcct_data.acct_type" readonly>
          </div>

          <div class="field-group" style="width: 15%;">
            <label>Local Chart:</label>
            <input type="text" class="form-control input-sm" [value]="firLocalChartAcct_data.local_chart" readonly>
          </div>

          <div class="field-group" style="width: 35%;">
            <label>Local Account:</label>
            <textarea class="form-control input-sm" rows="3" readonly>{{firLocalChartAcct_data.localaccts}}</textarea>
          </div>

          @if (!sysAcctHide) {
<div class="field-group" style="width: 35%;">
            <label>Tax Sensitive/System Account</label>
            @if (loadingFirSysAcct) {
<div class="loading-spinner">
              <i class="fa fa-spinner fa-spin" style="color: #e12827;"></i>
            </div>
}
            @if (!loadingFirSysAcct) {
<select 
                    class="form-control"
                    [(ngModel)]="fir_sys_acct_selected"
                    [ngModelOptions]="{standalone: true}"
                    (ngModelChange)="onSystemAcctChange()">
              <option value="Please select System Account">Please select System Account</option>
              @for (sysAcct of fir_sys_acc_dropdown_data; track $index) {
<option [value]="sysAcct">{{sysAcct}}</option>
}
            </select>
}
          </div>
}
        </div>

        <!-- Lookup Panel -->
        <div class="panel panel-default">
          <div class="panel-heading">
            <span>Lookup for System Acct to Form Line Mapping</span>
            <div class="panel-actions">
              <button type="button" class="btn btn-success btn-xs" (click)="firToggleLookup()">Lookup</button>
              <i class="fa" 
                 [ngClass]="{'fa-chevron-down': firLookUpMapping, 'fa-chevron-up': !firLookUpMapping}"
                 style="cursor: pointer; margin-left: 10px;"
                 (click)="firToggleLookup()"></i>
            </div>
          </div>

          @if (firLookUpMapping) {
<div class="panel-body">
            <!-- ALL 5 LOOKUP FIELDS IN ONE ROW -->
            <div class="lookup-row-inline">
              <div class="lookup-field" style="width: 15%;">
                <label>IRS Form</label>
                <select class="form-control input-sm"
                        [(ngModel)]="CHECK_FIR_FORM"
                        [ngModelOptions]="{standalone: true}"
                        (ngModelChange)="getFirLookupNext(1, 'SCHEDULE', CHECK_FIR_FORM); firFormchanged()">
                  <option value="">Select...</option>
                  @for (form of firLookupForm; track $index) {
<option [value]="form">{{form}}</option>
}
                </select>
              </div>

              <div class="lookup-field" style="width: 15%;">
                <label>Schedule</label>
                <select class="form-control input-sm"
                        [(ngModel)]="CHECK_FIR_SCHEDULE"
                        [ngModelOptions]="{standalone: true}"
                        [disabled]="!CHECK_FIR_FORM"
                        (ngModelChange)="getFirLookupNext(2, 'LINE', CHECK_FIR_SCHEDULE); firSchedulechanged()">
                  <option value="">Select...</option>
                  @for (schedule of firLookupSchedule; track $index) {
<option [value]="schedule">{{schedule}}</option>
}
                </select>
              </div>

              <div class="lookup-field" style="width: 20%;">
                <label>Line</label>
                <select class="form-control input-sm"
                        [(ngModel)]="CHECK_FIR_LINE"
                        [ngModelOptions]="{standalone: true}"
                        [disabled]="!CHECK_FIR_SCHEDULE"
                        (ngModelChange)="getFirLookupNext(3, 'COL', CHECK_FIR_LINE); firLinechanged()">
                  <option value="">Select...</option>
                  @for (line of firLookupLine; track $index) {
<option [value]="line">{{line}}</option>
}
                </select>
              </div>

              <div class="lookup-field" style="width: 10%;">
                <label>Column</label>
                <select class="form-control input-sm"
                        [(ngModel)]="CHECK_FIR_COL"
                        [ngModelOptions]="{standalone: true}"
                        [disabled]="!CHECK_FIR_LINE"
                        (ngModelChange)="getFirLookupNext(4, 'SYS_ACCT', CHECK_FIR_COL); firColumnchanged()">
                  <option value="">Select...</option>
                  @for (col of firLookupColumn; track $index) {
<option [value]="col">{{col}}</option>
}
                </select>
              </div>

              <div class="lookup-field" style="width: 38%;">
                <label>Mapped System Accounts</label>
                <select class="form-control input-sm"
                        [(ngModel)]="CHECK_FIR_SYS_MAP_ACCT"
                        [ngModelOptions]="{standalone: true}"
                        [disabled]="!CHECK_FIR_LINE">
                  <option value="">Select...</option>
                  @for (acct of firLookupSysMapAcct; track $index) {
<option [value]="acct">{{acct}}</option>
}
                </select>
              </div>
            </div>

            <div class="lookup-actions">
              <button type="button" class="btn btn-success btn-xs" (click)="applyFirChanges()">Apply Changes</button>
              <button type="button" class="btn btn-danger btn-xs" (click)="resetFirLookup()">Reset Changes</button>
            </div>
          </div>
}
        </div>

        <!-- Tax Sensitive Panel -->
        @if (firTaxSensLookup) {
<div class="panel panel-default">
          <div class="panel-heading">
            <span>TaxSensitive</span>
            <div class="panel-actions">
              <button type="button" class="btn btn-success btn-xs" (click)="firTaxsensitivetoggleLookup()">TaxSensitive</button>
              <i class="fa"
                 [ngClass]="{'fa-chevron-down': firTaxsensitivelookUpArrow, 'fa-chevron-up': !firTaxsensitivelookUpArrow}"
                 style="cursor: pointer; margin-left: 10px;"
                 (click)="firTaxsensitivetoggleLookup()"></i>
            </div>
          </div>

          @if (firTaxsensitivelookUpArrow) {
<div class="panel-body">
            @if (loadingFirTaxSensLookup) {
<div class="loading-spinner">
              <i class="fa fa-spinner fa-spin" style="color: #e12827; font-size: 36px;"></i>
            </div>
}

            @if (!loadingFirTaxSensLookup && fir_tax_sensitive_data.length > 0) {
<div class="table-responsive">
              <table class="table table-hover table-bordered table-striped table-condensed custom-table" style="table-layout: fixed;">
                <thead>
                  <tr class="tax-sensitive-header">
                    <th style="width: 4%;">Action</th>
                    <th style="width: 10%;">Trigger Local Acct</th>
                    <th style="width: 7%;">Tax Sensitivity</th>
                    <th style="width: 10%;">Income Statement Acct</th>
                    <th style="width: 10%;">Balance Sheet Acct</th>
                    <th style="width: 9%;">EP Type</th>
                    <th style="width: 8%;">5471 Schd H Line</th>
                    <th style="width: 8%;">8865 sch M-1 Line</th>
                    <th style="width: 10%;">Tax Adj Description</th>
                    <th style="width: 7%;">Perm-Temp Flag</th>
                    <th style="width: 6%;">Default Method</th>
                    <th style="width: 6%;">Permissible</th>
                    <th style="width: 5%;">MULTIPLIER</th>
                  </tr>
                </thead>
                <tbody>
                  @for (firTaxSensitive of fir_tax_sensitive_data; track $index) {
<tr>
                    <td class="text-center">
                      <i class="fa fa-edit pointer" (click)="firFormEdit(firTaxSensitive)"></i>
                    </td>
                    <td>{{firTaxSensitive.TRIGGER_LOCAL_ACCT}}</td>
                    <td>
                      @if (!firTaxSensitive.isEditable) {
<span>{{firTaxSensitive.LOCAL_ACCT_TAX_SENSITIVE?.value === 'Y' ? 'Yes' : 'No'}}</span>
}
                      @if (firTaxSensitive.isEditable) {
<select class="form-control input-sm"
                              [(ngModel)]="firTaxSensitive.LOCAL_ACCT_TAX_SENSITIVE"
                              [compareWith]="compareByValue"
                              [ngModelOptions]="{standalone: true}"
                              (change)="onFirTaxSensitivityUserChange(firTaxSensitive)">
                        @for (flag of flag_value; track $index) {
<option [ngValue]="flag">{{flag.flag}}</option>
}
                      </select>
}
                    </td>
                    <td>
                      @if (!isFirTaxSensitiveDetailEditable(firTaxSensitive)) {
<span>{{firTaxSensitive.POSTING_LOCAL_ACCT_DETAILS?.POSTING_LOCAL_ACCT}}</span>
}
                      @if (isFirTaxSensitiveDetailEditable(firTaxSensitive)) {
<select
                              class="form-control input-sm"
                              [(ngModel)]="firTaxSensitive.POSTING_LOCAL_ACCT_DETAILS"
                              [compareWith]="compareByPostingLocalAcctKey"
                              [ngModelOptions]="{standalone: true}">
                        @for (acct of firPostingLocalAcctList; track $index) {
<option [ngValue]="acct">{{acct.POSTING_LOCAL_ACCT}}</option>
}
                      </select>
}
                    </td>
                    <td>
                      @if (!isFirTaxSensitiveDetailEditable(firTaxSensitive)) {
<span>{{firTaxSensitive.OFFSET_LOCAL_ACCT_DETAILS?.OFFSET_LOCAL_ACCT}}</span>
}
                      @if (isFirTaxSensitiveDetailEditable(firTaxSensitive)) {
<select
                              class="form-control input-sm"
                              [(ngModel)]="firTaxSensitive.OFFSET_LOCAL_ACCT_DETAILS"
                              [compareWith]="compareByOffsetLocalAcctKey"
                              [ngModelOptions]="{standalone: true}">
                        @for (acct of firOffsetLocalAcctList; track $index) {
<option [ngValue]="acct">{{acct.OFFSET_LOCAL_ACCT}}</option>
}
                      </select>
}
                    </td>
                    <td>
                      @if (!isFirTaxSensitiveDetailEditable(firTaxSensitive)) {
<span>{{firTaxSensitive.EP_TYPE_DETAILS?.EP_TYPE_CODE}} - {{firTaxSensitive.EP_TYPE_DETAILS?.EP_TYPE_DESC}}</span>
}
                      @if (isFirTaxSensitiveDetailEditable(firTaxSensitive)) {
<select
                              class="form-control input-sm"
                              [(ngModel)]="firTaxSensitive.EP_TYPE_DETAILS"
                              [compareWith]="compareByEpTypeCode"
                              [ngModelOptions]="{standalone: true}"
                              (ngModelChange)="changeMultiplier(firTaxSensitive)">
                        @for (ep of firEPTypeList; track $index) {
<option [ngValue]="ep">{{ep.EP_TYPE_CODE}} - {{ep.EP_TYPE_DESC}}</option>
}
                      </select>
}
                    </td>
                    <td>
                      @if (!isFirTaxSensitiveDetailEditable(firTaxSensitive)) {
<span>{{firTaxSensitive.LINE_5471_DETAILS?.LINE_NO}}</span>
}
                      @if (isFirTaxSensitiveDetailEditable(firTaxSensitive)) {
<select
                              class="form-control input-sm"
                              [(ngModel)]="firTaxSensitive.LINE_5471_DETAILS"
                              [compareWith]="compareByLine5471"
                              [ngModelOptions]="{standalone: true}">
                        @for (line of form5471SchdH; track $index) {
<option [ngValue]="line">{{line.LINE_NO}} - {{line.DESCRIPTION}}</option>
}
                      </select>
}
                    </td>
                    <td>
                      @if (!isFirTaxSensitiveDetailEditable(firTaxSensitive)) {
<span>{{firTaxSensitive.LINE_8865_DETAILS?.LINE}}</span>
}
                      @if (isFirTaxSensitiveDetailEditable(firTaxSensitive)) {
<select
                              class="form-control input-sm"
                              [(ngModel)]="firTaxSensitive.LINE_8865_DETAILS"
                              [compareWith]="compareByLine8865"
                              [ngModelOptions]="{standalone: true}">
                        @for (line of form8865SchdM1; track $index) {
<option [ngValue]="line">{{line.LINE}} - {{line.DESCRIPTION}}</option>
}
                      </select>
}
                    </td>
                    <td>
                      @if (!isFirTaxSensitiveDetailEditable(firTaxSensitive)) {
<span>{{firTaxSensitive.EP_DESC}}</span>
}
                      @if (isFirTaxSensitiveDetailEditable(firTaxSensitive)) {
<input
                             type="text" class="form-control input-sm"
                             [(ngModel)]="firTaxSensitive.EP_DESC"
                             [ngModelOptions]="{standalone: true}">
}
                    </td>
                    <td>
                      @if (!isFirTaxSensitiveDetailEditable(firTaxSensitive)) {
<span>{{firTaxSensitive.PERM_TEMP_FLAG?.flag}}</span>
}
                      @if (isFirTaxSensitiveDetailEditable(firTaxSensitive)) {
<select
                              class="form-control input-sm"
                              [(ngModel)]="firTaxSensitive.PERM_TEMP_FLAG"
                              [compareWith]="compareByValue"
                              [ngModelOptions]="{standalone: true}">
                        @for (pt of permTempFlag; track $index) {
<option [ngValue]="pt">{{pt.flag}}</option>
}
                      </select>
}
                    </td>
                    <td>
                      @if (!isFirTaxSensitiveDetailEditable(firTaxSensitive)) {
<span>{{firTaxSensitive.DEFAULT_METHOD?.flag}}</span>
}
                      @if (isFirTaxSensitiveDetailEditable(firTaxSensitive)) {
<select
                              class="form-control input-sm"
                              [(ngModel)]="firTaxSensitive.DEFAULT_METHOD"
                              [compareWith]="compareByValue"
                              [ngModelOptions]="{standalone: true}">
                        @for (opt of yesNoOptions; track $index) {
<option [ngValue]="opt">{{opt.flag}}</option>
}
                      </select>
}
                    </td>
                    <td>
                      @if (!isFirTaxSensitiveDetailEditable(firTaxSensitive)) {
<span>{{firTaxSensitive.PERMISSIBLE?.flag}}</span>
}
                      @if (isFirTaxSensitiveDetailEditable(firTaxSensitive)) {
<select
                              class="form-control input-sm"
                              [(ngModel)]="firTaxSensitive.PERMISSIBLE"
                              [compareWith]="compareByValue"
                              [ngModelOptions]="{standalone: true}">
                        @for (opt of yesNoOptions; track $index) {
<option [ngValue]="opt">{{opt.flag}}</option>
}
                      </select>
}
                    </td>
                    <td>
                      @if (!isFirTaxSensitiveDetailEditable(firTaxSensitive)) {
<span>{{firTaxSensitive.MULTIPLIER}}</span>
}
                      @if (isFirTaxSensitiveDetailEditable(firTaxSensitive)) {
<input
                             type="number" class="form-control input-sm"
                             [(ngModel)]="firTaxSensitive.MULTIPLIER"
                             [ngModelOptions]="{standalone: true}">
}
                    </td>
                  </tr>
}
                </tbody>
              </table>

              <div class="text-center" style="margin-top: 10px;">
                <button type="button" class="btn btn-danger btn-xs" (click)="resetFirTaxSensLookup()">Reset Changes</button>
              </div>
            </div>
}

            @if (!loadingFirTaxSensLookup && fir_tax_sensitive_data.length === 0) {
<div class="no-data-message">
              No tax sensitive data available.
            </div>
}
          </div>
}
        </div>
}

        <!-- IRS Form Table (rendered inside the form body, above the footer buttons) -->
        @if (firIRSFormData && firIRSFormData.length > 0) {
<div class="irs-form-section">
          <table class="table table-hover table-bordered table-striped table-condensed irs-form-table">
            <thead>
              <tr class="irs-form-header">
                <th class="sortable" (click)="sortBy('1', sort_key['1'])">
                  <i class="fa" [ngClass]="{
                    'fa-sort': sort_key['1'] === 0,
                    'fa-sort-asc': sort_key['1'] === 1,
                    'fa-sort-desc': sort_key['1'] === 2
                  }"></i> IRS Form
                </th>
                <th class="sortable" (click)="sortBy('2', sort_key['2'])">
                  <i class="fa" [ngClass]="{
                    'fa-sort': sort_key['2'] === 0,
                    'fa-sort-asc': sort_key['2'] === 1,
                    'fa-sort-desc': sort_key['2'] === 2
                  }"></i> Schedule
                </th>
                <th class="sortable" (click)="sortBy('3', sort_key['3'])">
                  <i class="fa" [ngClass]="{
                    'fa-sort': sort_key['3'] === 0,
                    'fa-sort-asc': sort_key['3'] === 1,
                    'fa-sort-desc': sort_key['3'] === 2
                  }"></i> Line No.
                </th>
                <th class="sortable" (click)="sortBy('4', sort_key['4'])">
                  <i class="fa" [ngClass]="{
                    'fa-sort': sort_key['4'] === 0,
                    'fa-sort-asc': sort_key['4'] === 1,
                    'fa-sort-desc': sort_key['4'] === 2
                  }"></i> Line Description.
                </th>
                <th class="sortable" (click)="sortBy('5', sort_key['5'])">
                  <i class="fa" [ngClass]="{
                    'fa-sort': sort_key['5'] === 0,
                    'fa-sort-asc': sort_key['5'] === 1,
                    'fa-sort-desc': sort_key['5'] === 2
                  }"></i> Column
                </th>
              </tr>
            </thead>
            <tbody>
              @for (irsData of firIRSFormData; track $index) {
<tr>
                <td>{{irsData.FORM}}</td>
                <td>{{irsData.SCHEDULE}}</td>
                <td>{{irsData.LINE}}</td>
                <td>{{irsData.LINE_DESC}}</td>
                <td>{{irsData.COL}}</td>
              </tr>
}
            </tbody>
          </table>
        </div>
}

        <!-- Modal Footer INSIDE the form -->
        <div class="modal-footer-inner">
          <button class="btn btn-info btn-sm"
                  type="button"
                  [disabled]="isSaveClicked"
                  (click)="save()">
            @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save
          </button>

          <button class="btn btn-danger-outline btn-sm"
                  type="button"
                  (click)="reset()">Reset</button>

          <button class="btn btn-warning btn-sm"
                  type="button"
                  (click)="cancel()">Cancel</button>
        </div>

      </div>
}
    </form>
  </div>
</div>
